import { 
  FETCH_FOLDER_BLACKLIST_SUCCESS,
  FETCH_FOLDER_BLACKLIST_PENDING,
  FETCH_FOLDER_BLACKLIST_ERROR,
} from '../constants/Constants';

const initialState = {
  pending: false,
  data:    [],
  error:   '',
}

export const requestFolderBlackListReducer = (state = initialState, action) => {
  
  switch (action.type) {
      case FETCH_FOLDER_BLACKLIST_PENDING: return { ...state, pending: true, }
      case FETCH_FOLDER_BLACKLIST_SUCCESS: return { ...state, pending: false, data: action.payload, }
      case FETCH_FOLDER_BLACKLIST_ERROR:   return { ...state, pending: false, error: action.payload, }
      default: return state;
  }
}
